import React, { useState } from "react";
import { IMAGE_BASE_URL } from "../../config/api";
import DeletConfirmation from "../../atoms/deletConfirmation";
import { removeProjectAllocation } from "../../services/service";

export const formatWorkedDuration = (totalSeconds) => {
  const seconds = Number(totalSeconds) || 0;
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (hours === 0 && minutes === 0) return "0m";
  if (hours === 0) return `${minutes}m`;
  return `${hours}h ${minutes}m`;
};

const WorkerHoursBadge = ({ seconds }) => (
  <span
    title="Total hours worked on this project"
    className="flex items-center gap-1 bg-[#DEE2ED] text-[#1E3A8A] text-[11px] font-medium px-2 py-1 rounded-full whitespace-nowrap"
  >
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="9" />
      <polyline points="12 7 12 12 15.5 14" />
    </svg>
    {formatWorkedDuration(seconds)}
  </span>
);

const WorkersBar = ({ handleOpenWorkerbar, workersData,refreshWorkers }) => {
  const allocatedUsers = workersData?.AllocatedUsers?.filter(
    (user) => !user.projectAllocation.deleted
  );
  const [isDeleteWorkerVisible, setIsDeleteWorkerVisible] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [selectedWorkerId, setSelectedWorkerId] = useState(null);

  const handleDeleteWorkerClick = (id) => {
    if (!id) return;
    setSelectedWorkerId(id);
    setIsDeleteWorkerVisible(true);
  };

  const closeModal = () => {
    setIsDeleteWorkerVisible(false);
    setSelectedWorkerId(null);
  };

  const handleWorkerDelete = async () => {
    if (!selectedWorkerId) return;
    setLoading(true);
    const data = {
      project_id: workersData?.id,
      user_id: selectedWorkerId,
    };
    await removeProjectAllocation(data);
    setLoading(false);
    refreshWorkers();
    closeModal();
    // setDeleteSuccess(!deleteSuccess);
  };

  return (
    <>
      <div className="w-full flex items-center justify-between py-2">
        <p className="text-lg font-semibold text-[#1E3A8A]">Workers</p>
        <button
          onClick={handleOpenWorkerbar}
          className="bg-[#F97316] hover:bg-orange-600 text-white text-sm font-medium px-2 pb-1 h-[30px] rounded"
        >
          Assign Worker
        </button>
      </div>
      {allocatedUsers && allocatedUsers.length > 0 ? (
        allocatedUsers.map((worker) => (
          <label
            key={worker?.id}
            className="flex flex-col gap-4 items-start space-x-3 cursor-pointer"
          >
            <div className="flex items-center w-full justify-between cursor-pointer space-x-3">
              <div className="flex items-center gap-3">
                <div className="w-[36px] h-[36px] rounded-full flex justify-center items-center bg-green-500 text-[20px] font-semibold text-white">
                  {worker?.image ? (
                    <img
                      src={IMAGE_BASE_URL + worker?.image}
                      alt="Worker"
                      className="w-full h-full rounded-full"
                    />
                  ) : (
                    worker?.username
                      ?.split(" ")
                      ?.map((n) => n[0])
                      .join("")
                      .toUpperCase()
                  )}
                </div>
                <p className="text-[14px] text-[#4B5563] text-normal">
                  {worker?.username}
                </p>
              </div>
              <div className="flex items-center gap-3">
                <WorkerHoursBadge seconds={worker?.total_worked_seconds} />
                <p
                  className="font-medium text-[14px] text-[#E90C0C] cursor-pointer"
                  onClick={() => handleDeleteWorkerClick(worker?.id)}
                >
                  Remove
                </p>
              </div>
            </div>
            <div className="w-full h-[1px] bg-[#EFEFEF]"></div>
          </label>
        ))
      ) : (
        <p>No workers are allocated</p>
      )}

      {isDeleteWorkerVisible && (
        <DeletConfirmation
          onClose={closeModal}
          deleteModal={handleDeleteWorkerClick}
          setDeleteModal={setIsDeleteWorkerVisible}
          handleDelete={handleWorkerDelete}
          isLoading={Loading}
          workerRemove={true}
        />
      )}
    </>
  );
};

export default WorkersBar;
